// extracted by mini-css-extract-plugin
var _1 = "EpostValidationErrors-moduleEpostValidationErrors__koSd6";
var _2 = "EpostValidationErrors-moduledivider__aMdbl Divider-moduleDivider__dL3Vg";
var _3 = "EpostValidationErrors-moduleheaderWrapper__gQtBa";
export { _1 as "EpostValidationErrors", _2 as "divider", _3 as "headerWrapper" }
